const consent = {
  title: "ประกันเดินทางภายในประเทศ",
  description: `เที่ยวไทยให้สนุก ยิ้มได้ทุกจังหวัด หมดกังวล อุบัติเหตุเล็กใหญ่ระหว่างเดินทาง คุ้มครองคุณสูงสุดถึง 2 ล้านบาท (ตามเงื่อนไขในกรมธรรม์)`,
  benefits: [
    {
      title: "",
      detail: "หมวดความคุ้มครอง",
      items: [
        {
          index: `1. ผลประโยชน์การเสียชีวิต ทุพพลภาพถาวรสิ้นเชิง สูญเสีย มือ เท้า และสายตา จากอุบัติเหตุ <br/> * (ไม่รวมอุบัติเหตุจากการขับขี่/โดยสารรถจักรยานยนต์)`,
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "300,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "500,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "1,000,000",
                },
                {
                  name: "แบบที่ 4",
                  price: "1,500,000",
                },
                {
                  name: "แบบที่ 5",
                  price: "2,000,000",
                },
              ],
            },
          ],
        },
        {
          index: "2. ผลประโยชน์ค่ารักษาพยาบาล ต่ออุบัติเหตุ <br/> * แต่ละครั้ง",
          ranges: [
            {
              name: "ทุนประกันภัย (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "30,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "50,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "100,000",
                },
                {
                  name: "แบบที่ 4",
                  price: "150,000",
                },
                {
                  name: "แบบที่ 5",
                  price: "200,000",
                },
              ],
            },
          ],
        },
      ],
      timesHeaders: [
        "แบบที่ 1",
        "แบบที่ 2",
        "แบบที่ 3",
        "แบบที่ 4",
        "แบบที่ 5",
      ],
      times: [
        {
          day: "3 วัน",
          price: {
            "แบบที่ 1": 87.74,
            "แบบที่ 2": 145.52,
            "แบบที่ 3": 291.04,
            "แบบที่ 4": 435.49,
            "แบบที่ 5": 581.01,
          },
        },
        {
          day: "5 วัน",
          price: {
            "แบบที่ 1": 119.84,
            "แบบที่ 2": 199.02,
            "แบบที่ 3": 398.04,
            "แบบที่ 4": 597.06,
            "แบบที่ 5": 795.01,
          },
        },
        {
          day: "7 วัน",
          price: {
            "แบบที่ 1": 132.68,
            "แบบที่ 2": 220.42,
            "แบบที่ 3": 440.84,
            "แบบที่ 4": 661.26,
            "แบบที่ 5": 881.68,
          },
        },
        {
          day: "10 วัน",
          price: {
            "แบบที่ 1": 151.94,
            "แบบที่ 2": 252.52,
            "แบบที่ 3": 505.04,
            "แบบที่ 4": 757.56,
            "แบบที่ 5": 1010.08,
          },
        },
        {
          day: "14 วัน",
          price: {
            "แบบที่ 1": 187.25,
            "แบบที่ 2": 312.44,
            "แบบที่ 3": 623.81,
            "แบบที่ 4": 935.18,
            "แบบที่ 5": 1246.55,
          },
        },
        {
          day: "17 วัน",
          price: {
            "แบบที่ 1": 206.51,
            "แบบที่ 2": 344.54,
            "แบบที่ 3": 688.01,
            "แบบที่ 4": 1031.48,
            "แบบที่ 5": 1376.02,
          },
        },
        {
          day: "21 วัน",
          price: {
            "แบบที่ 1": 238.61,
            "แบบที่ 2": 398.04,
            "แบบที่ 3": 795.01,
            "แบบที่ 4": 1193.05,
            "แบบที่ 5": 1590.02,
          },
        },
        {
          day: "24 วัน",
          price: {
            "แบบที่ 1": 261.08,
            "แบบที่ 2": 435.49,
            "แบบที่ 3": 870.98,
            "แบบที่ 4": 1305.4,
            "แบบที่ 5": 1740.89,
          },
        },
        {
          day: "27 วัน",
          price: {
            "แบบที่ 1": 284.62,
            "แบบที่ 2": 472.94,
            "แบบที่ 3": 945.88,
            "แบบที่ 4": 1418.82,
            "แบบที่ 5": 1891.76,
          },
        },
        {
          day: "31 วัน",
          price: {
            "แบบที่ 1": 316.72,
            "แบบที่ 2": 526.44,
            "แบบที่ 3": 1052.88,
            "แบบที่ 4": 1579.32,
            "แบบที่ 5": 2105.76,
          },
        },
      ],
    },
  ],
  conditions: [
    {
      title: "",
      detail: "เงื่อนไขการรับประกันภัย",
      items: [
        {
          index:
            "1. อัตราเบี้ยประกันภัยข้างต้นสำหรับผู้เอาประกันภัยที่มีอายุตั้งแต่ 1 - 60 ปีเท่านั้น สำหรับอายุ 1 - 15 ปีทำทุนประกันภัยได้สูงสุดไม่เกิน 500,000 บาท",
        },
        {
          index:
            "2. ในช่วงเวลาเดินทางเดียวกัน สามารถทำประกันภัยได้สูงสุด 1 กรมธรรม์/ผู้เอาประกันภัย",
        },
        {
          index:
            "3. กิจกรรมที่ไม่ได้รับความคุ้มครอง ได้แก่ ล่าสัตว์, แข่งรถหรือแข่งเรือทุกชนิด, แข่งม้า, เล่นหรือแข่งสกีทุกชนิดรวมถึงเจ็ตสกี, แข่งสเก็ต, ชกมวย, โดดร่ม (เว้นแต่เป็นการโดดร่มเพื่อรักษาชีวิต), ขณะกำลังขึ้นหรือกำลังลงหรือโดยสารอยู่ในบอลลูน, เครื่องร่อน, เล่นบันจี้จั๊มพ์, ปีนหรือไต่เขา, ดำน้ำที่ต้องใช้ถังอากาศ",
        },
        {
          index:
            "4. ไม่คุ้มครองกรณีที่เดินทางโดยยานพาหนะ ดังต่อไปนี้ <br/><li> การขับขี่หรือโดยสารรถจักรยานยนต์ ( ทั้งในขณะเดินทางและระหว่างการท่องเที่ยว ) <br/><li> ยานพาหนะที่ไม่ได้จดทะเบียนเพื่อบรรทุกผู้โดยสาร และไม่ได้ประกอบการโดยสารการบินพาณิชย์  <br/><li> ขณะผู้เอาประกันภัยขับขี่หรือปฏิบัติหน้าที่เป็นพนักงานประจำยานพาหนะใดๆ <br/><li> อากาศยานที่มิได้ประกอบการโดยสายการบินพาณิชย์",
        },
        {
          index:
            "5. รายละเอียดความคุ้มครองและข้อยกเว้นอื่นๆ เป็นไปตามกรมธรรม์ประกันภัยอุบัติเหตุเดินทางสำหรับบุคคลและกลุ่มทั่วไป ",
        },
      ],
    },
  ],
  exceptions: [
    {
      title: "",
      detail: "หมายเหตุ",
      items: [
        {
          index: "1. เงื่อนไขความคุ้มครองและข้อยกเว้นเป็นไปตามกรมธรรม์",
        },
        {
          index:
            "2. ผู้ซื้อควรทำความเข้าใจในรายละเอียดความคุ้มครองและเงื่อนไขก่อนตัดสินใจทำประกันภัย",
        },
      ],
    },
  ],
  services: [
    {
      title: "",
      detail: "ศูนย์บริการลูกค้า (Customer Service Center)",
      items: [
        {
          index: "<li> ทาง Call Center โทร.1484",
        },
      ],
    },
  ],
};

export default consent;
